/*
|----------------------------------------------------------
|   Elementor:
|---------------------------------------------------------
|   Use this module to add all function related
|   to all Elementor features and fixes
|
*/

import config from "./config";

export default {

    /**
     * Swaps the Elementor main menu to update state,
     * when loading a new page via pjax.
     * IMPORTANT: We discontinue this function becuase it
     * caused mobile menu bugs.
     * @param   Object  pjax    must pass the ITM.pjax object
     */
    swapElementorMenu: function(pjax) {
        if (config.debug) console.log('swapElementorMenu');
        var $newBar = jQuery(pjax.newDocument).find('.elementor-nav-menu--main')
        if (config.debug) console.log('toggle', $toggle);
        jQuery('.elementor-nav-menu--main').html($newBar.html())

    },

    /**
     * Fixes elementor menu caret duplication bug.
     * This feature is NOT needed when using the function
     * swapElementorMenu above.
     *
     * We fixed this by removing the caret on page load,
     * and then letting elementor append the new caret on load which is the
     * default behavior.
     */
    menuCarets: function() {
        if (config.debug) {
            console.log("elementor/carets");
        }

        let hasSubmenu = jQuery('.elementor-nav-menu .menu-item .has-submenu');

        // remove caret on page load
        if(hasSubmenu){
            hasSubmenu.find('.sub-arrow').remove();
        }
    },

    /**
     * Detects if the page is the Elementor Editor
     *
     * @return  Boolean
     */
    isEditor: function() {

        if (typeof window.elementorFrontend === 'object') {
            if (elementorFrontend.isEditMode())
                return true
        }

        return false
    },

    /**
     * Removes sticky sidebar div styles
     * generated by the elementor to reset it's state
     * on pjax loads
     *
     */
    resetStickyItems: function (ITM) {
        if (config.debug) {
            console.log("resetStickyItems");
        }
        /**
         * Sidebar sticky
         */
        jQuery('.elementor-widget-sidebar.elementor-sticky').removeAttr("style");

        /**
         * Sticky main nav
         */
        setTimeout(() => {
            console.log("resetStickyItems", "setTimeout");
            jQuery(document).find('#pjax-wrapper .elementor-location-header .elementor-sticky--active').removeClass('elementor-sticky--active').css({ "position": "relative", "width": window.innerWidth });
        }, 400);

        /**
         * Sticky main nav duplicated menu spacer
         * Elementor duplicates the main menu as an spacer for some reason
         * when loading the page and deletes it after scrolling
         */
        jQuery('.elementor-location-header .elementor-sticky__spacer').css({ "height": 0 });
    },

    /**
     * Add support for native Elementor popUp widgets
     */
    popUpSupport: function (ITMObj) {
        if (typeof window.elementorFrontend === 'object') {
            if (config.debug) console.log("popUpSupport() elementorFrontend found....");

          try {

            if (config.debug) {
                console.log("elementorFrontend before init:"); console.log(elementorFrontend.documentsManager.documents);
            }

            if (elementorFrontend.documentsManager.documents && elementorFrontend.documentsManager.documents != 'undefined') {

                if (config.debug) console.log('elementorFrontend.documentsManager.documents found.....');

                var popUpModelArr = [];

                //get before elementorFrontend.init()
                jQuery.each(elementorFrontend.documentsManager.documents, (id, documentObj) => {
                    // It's a popup document
                    if (documentObj.getModal) {

                        if (config.debug) console.log('popup model......... ' + id);

                        var obj_mod = {};
                        obj_mod['id'] = id;
                        obj_mod['obj'] = documentObj;
                        popUpModelArr.push(obj_mod);

                    }
                });

            } else {
                if (config.debug) console.log('elementorFrontend.documentsManager.documents not found.....');
            }

            elementorFrontend.init();

            //put back after elementorFrontend.init()
            for (var i = 0; i < popUpModelArr.length; i++) {
                var obj_mod = popUpModelArr[i];
                elementorFrontend.documentsManager.documents[obj_mod.id] = obj_mod.obj;
            }

            if (config.debug) {
                console.log("elementorFrontend after init:"); console.log(elementorFrontend.documentsManager.documents);
            }

         }catch(error){
            console.log('popUpSupport Error:', error)
         }

        }//End of if (typeof window.elementorFrontend === 'object')
        else {
            console.log("popUpSupport() elementorFrontend not found....");
        }

    },

    /**
     * Add support Breaking news widget
     */
    breakingNewsSupport: function (ITMObj) {

        if (typeof window.elementorFrontend === 'object') {

            var setWidth = 0; var chkWidth = 0;

            //var tickerObj = jQuery(ITMObj.pjax.newDocument).find( '.jet-text-ticker__posts' );
            var tickerObj = jQuery(document).find( '.jet-text-ticker__posts' );
            //console.log(tickerObj); //console.log(tickerObj.find('.slick-track'));

            chkWidth = tickerObj.find('.slick-track').width();

            if (chkWidth > 0) {
                ITMObj.ticker_width = chkWidth;
            }
            else {
                setWidth = 1;
            }

            if (config.debug) console.log("breakingNewsSupport() checking...."+ITMObj.ticker_width+' >> '+setWidth+' >> '+chkWidth);

            if (setWidth) {
                if (config.debug) console.log('here slick : set text ticker width again......');
                //console.log(ITMObj.ticker.find('.slick-track'));

                //tickerObj.find('.slick-track').css({'width':ITMObj.ticker_width+'px'});
                //tickerObj.find('.slick-slide').css({'width':ITMObj.ticker_width+'px'});

                jQuery(".slick-track").css({'width':ITMObj.ticker_width+'px'});
                jQuery(".slick-slide").css({'width':ITMObj.ticker_width+'px'});
            }

        }
        else {
            console.log("breakingNewsSupport() elementorFrontend not found....");
        }

    }
}
